export abstract class Constants {
    static readonly BULK_CLASS_ACCESS_GROUPS = ['U10_JDU_ADM_EXT_ATR4', 'U10_JDU_ADM_EXT_CF', 'U10_JDU_ADM_EXT_FIN',
        'U10_JDU_ADM_EXT_JDPS', 'U10_JDU_ADM_EXT_LATAM', 'U10_JDU_ADM_INT_CHNADM', 'U10_JDU_ADM_INT_EAMEADM',
        'U10_JDU_ADM_INT_INDADM', 'U10_JDU_ADM_INT_LATADM', 'U10_JDU_ADM_INT_USCADM', 'U10_JDU_ADM_SFTYADM',
        'U10_JDU_ADM_SFTYENTADM', 'U10_JDU_ADM_ENTADM', 'U10_JDU_ADM_EXT_AFRASIA', 'U10_JDU_ADM_EXT_ATR2',
        'U10_JDU_ADM_SYSADM', 'U10_JDU_ADM_SUPERADM'];

    static readonly JDU_BILLING_ACCESS_GROUPS = ['G90_JDU_BILLING_OPERATIONS', 'U10_JDU_ADM_SYSADM'];
}
